import { get } from './get';
import { _getProperty, _isArray, _isRecord, _setProperty, _shallowClone } from './helpers';
export function set(source, key, value) {
    if (!key) {
        if (_isArray(value) || _isRecord(value)) {
            return value;
        }
        throw new Error('set: cannot replace value with a non-record value');
    }
    if (get(source, key) === value) {
        return source;
    }
    var target = _shallowClone(source);
    var path = key.split('/');
    var currSource = source;
    var currTarget = target;
    while (path.length) {
        var prop = path.shift();
        if (path.length) {
            var nextSource = _getProperty(currSource, prop);
            if (nextSource === undefined) {
                nextSource = {};
                _setProperty(currSource, prop, nextSource);
            }
            if (!_isArray(nextSource) && !_isRecord(nextSource)) {
                throw new Error("set: path is not targeting an object nor an array: \"" + key + "\"");
            }
            currSource = nextSource;
            var nextTarget = _shallowClone(currSource);
            _setProperty(currTarget, prop, nextTarget);
            currTarget = nextTarget;
        }
        else {
            _setProperty(currTarget, prop, value);
        }
    }
    return target;
}
